import {
  TModelsListingProps,
  TModelsListingFields,
  TModelsData,
} from "../types/ModelsListing.types";
import mock from "../../../mocks/ModelsListing.mock";

export class ModelsListingModel {
  private readonly fields: null | TModelsListingFields;
  constructor(props: TModelsListingProps) {
    this.fields = props.fields || null;
  }

  get modelsListData(): TModelsData | undefined {
    return this.fields?.apiData;
  }

  get url(): string {
    return (
      this.fields?.itemData?.contextItemUrl ??
      mock.fields.itemData.contextItemUrl
    );
  }
}
